













import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import railwayInterface from '../interface/railway';
import userInterface from '../interface/user';
import Train from './Train.vue';
// import Storage from '../localStorage/storage';

// const storage = new Storage();

@Component({
  components: {
    Train,
  },

  computed: {
    ...mapGetters(['getUsers', 'getCurrentColor', 'getCompletedLength']),
  },
})
export default class Railway extends Vue {
  @Prop({ default: [] }) private railway!: railwayInterface;

  @Prop({ default: [] }) private users!: userInterface[];

  @Prop({ default: [] }) private isUserActive!: boolean;

  transform = this.railway.transform;

  getUsers!: userInterface[];

  getCurrentColor!: string

  isHover = false;

  // get currentUser(): userInterface | undefined {
  //   return this.getUsers.find((u) => u.name === this.getCurrentName);
  // }

  // get userColor(): string {
  //   let color = this.users.find((u) => u.name === storage.data.name)?.color;
  //   if (!color) color = '';
  //   return color;
  // }
}
